<script setup>
import RiskLabel from '@/Pages/DomainScore/Partials/RiskLabel.vue';
import RiskDescription from '@/Pages/DomainScore/Partials/RiskDescription.vue';
import CircularScore from '@/Components/Chart/CircularScore.vue';
import FlaredScoreCard from '@/Pages/DomainScore/Partials/FlaredScoreCard.vue';
import OutlinedButton from '@/Components/Button/OutlinedButton.vue';
import LinkOpenInNew from '@/Components/LinkOpenInNew.vue';
import PrimaryButton from '@/Components/Button/PrimaryButton.vue';
import BrandingCard from '@/Pages/DomainScore/Partials/Embed/BrandingCard.vue';
import ImpersonationCard from '@/Pages/DomainScore/Partials/Embed/ImpersonationCard.vue';
import PrivacyCard from '@/Pages/DomainScore/Partials/Embed/PrivacyCard.vue';

defineProps({
  score: Object,
  domain: String,
  partnerLogo: {
    type: [Object, null]
  }
});
</script>

<template>
  <div class="bg-highlight w-full pt-2 pb-20">
    <div class="overflow-hidden rounded-t-3xl">
      <FlaredScoreCard
        v-if="score.hasOwnProperty('score_pct')"
        :score="score.score_pct"
        class="!overflow-visible"
      >
        <div class="relative z-10">
          <div class="flex gap-4">
            <div class="flex w-full shrink-0 flex-col justify-between">
              <div class="flex">
                <div class="w-full">
                  <RiskLabel
                    class="text-xl font-semibold"
                    :score="score.score_pct"
                    :use-rating-to-calculate="false"
                  />
                  <RiskDescription class="text-sm" :score="score.score_pct" />
                  <div class="flex gap-2 pt-6">
                    <a :href="route('score.show', [domain])" target="_blank">
                      <PrimaryButton>
                        <div class="flex">
                          {{ $t('domain_score.embed.view_detailed_report') }}
                          <LinkOpenInNew
                            class="text-white-500 hover:text-white-500"
                          ></LinkOpenInNew>
                        </div>
                      </PrimaryButton>
                    </a>
                    <a :href="route('score.export', [domain])" target="_blank">
                      <OutlinedButton
                        datadog-action-name="Download Report - detail view"
                      >
                        {{ $t('domain_score.embed.download') }}
                      </OutlinedButton>
                    </a>
                  </div>
                </div>
                <div class="-mr-4 flex flex-col items-center">
                  <div class="mb-1 pt-0 font-bold md:block">
                    {{ $t('domain_score.embed.overall_score') }}
                  </div>
                  <CircularScore
                    class="max-w-[180px]"
                    :score="score.score_pct"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </FlaredScoreCard>
      <div
        class="dark bg-highlight text-highlight-content flex flex-col gap-4 p-6 pt-2 text-sm"
      >
        <ImpersonationCard :score="score" />
        <PrivacyCard :score="score" />
        <BrandingCard :score="score" />
      </div>
    </div>
  </div>
</template>
